import axios from 'axios';
import config from 'config.js';

// Constants
const GET_USERS_REQUEST = 'statistics/GET_USERS_REQUEST';
const GET_USERS_SUCCESS = 'statistics/GET_USERS_SUCCESS';
const GET_USERS_FAILURE = 'statistics/GET_USERS_FAILURE';

const GET_FORMS_REQUEST = 'statistics/GET_FORMS_REQUEST';
const GET_FORMS_SUCCESS = 'statistics/GET_FORMS_SUCCESS';
const GET_FORMS_FAILURE = 'statistics/GET_FORMS_FAILURE';

const GET_SUBMISSIONS_REQUEST = 'statistics/GET_SUBMISSIONS_REQUEST';
const GET_SUBMISSIONS_SUCCESS = 'statistics/GET_SUBMISSIONS_SUCCESS';
const GET_SUBMISSIONS_FAILURE = 'statistics/GET_SUBMISSIONS_FAILURE';

const GET_TOP_VIEWED_FORMS_REQUEST = 'statistics/GET_TOP_VIEWED_FORMS_REQUEST';
const GET_TOP_VIEWED_FORMS_SUCCESS = 'statistics/GET_TOP_VIEWED_FORMS_SUCCESS';
const GET_TOP_VIEWED_FORMS_FAILURE = 'statistics/GET_TOP_VIEWED_FORMS_FAILURE';

const GET_TOP_USED_THEMES_REQUEST = 'statistics/GET_TOP_USED_THEMES_REQUEST';
const GET_TOP_USED_THEMES_SUCCESS = 'statistics/GET_TOP_USED_THEMES_SUCCESS';
const GET_TOP_USED_THEMES_FAILURE = 'statistics/GET_TOP_USED_THEMES_FAILURE';

const getEndpointStatus = (type) => {
  const types = {
    request: {
      loading: true,
      error: false,
      success: false
    },
    success: {
      loading: false,
      error: false,
      success: true
    },
    failure: {
      loading: false,
      error: true,
      success: false
    },
  };

  return types[type];
};

const endpoitInitialStatus = {
  loading: false,
  error: false,
  success: false
};

// Initiual State
const initialState = {
  users: null,
  forms: null,
  submissions: null,
  topViewedForms: null,
  topUsedThemes: null,

  getUsers: { ...endpoitInitialStatus },
  getForms: { ...endpoitInitialStatus },
  getSubmissions: { ...endpoitInitialStatus },
  getTopViewedForms: { ...endpoitInitialStatus },
  getTopUsedThemes: { ...endpoitInitialStatus }
};

// Reducer
export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  if (action.type === GET_USERS_REQUEST) {
    state.getUsers = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_USERS_SUCCESS) {
    state.getUsers = getEndpointStatus('success');
    state.users = action.payload;

    return { ...state };
  }

  if (action.type === GET_USERS_FAILURE) {
    state.getUsers = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === GET_FORMS_REQUEST) {
    state.getForms = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_FORMS_SUCCESS) {
    state.getForms = getEndpointStatus('success');
    state.forms = action.payload;

    return { ...state };
  }

  if (action.type === GET_FORMS_FAILURE) {
    state.getForms = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === GET_SUBMISSIONS_REQUEST) {
    state.getSubmissions = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_SUBMISSIONS_SUCCESS) {
    state.getSubmissions = getEndpointStatus('success');
    state.submissions = action.payload;

    return { ...state };
  }

  if (action.type === GET_SUBMISSIONS_FAILURE) {
    state.getSubmissions = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === GET_TOP_VIEWED_FORMS_REQUEST) {
    state.getTopViewedForms = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_TOP_VIEWED_FORMS_SUCCESS) {
    state.getTopViewedForms = getEndpointStatus('success');
    state.topViewedForms = action.payload;

    return { ...state };
  }

  if (action.type === GET_TOP_VIEWED_FORMS_FAILURE) {
    state.getTopViewedForms = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === GET_TOP_USED_THEMES_REQUEST) {
    state.getTopUsedThemes = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_TOP_USED_THEMES_SUCCESS) {
    state.getTopUsedThemes = getEndpointStatus('success');
    state.topUsedThemes = action.payload;

    return { ...state };
  }

  if (action.type === GET_TOP_USED_THEMES_FAILURE) {
    state.getTopUsedThemes = getEndpointStatus('failure');

    return { ...state };
  }

  return state;
}

// Action Creators
export function getUsers(days) {
  const request = () => { return { type: GET_USERS_REQUEST } };
  const success = (res) => { return { type: GET_USERS_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_USERS_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getUsers({days});

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function getForms(days) {
  const request = () => { return { type: GET_FORMS_REQUEST } };
  const success = (res) => { return { type: GET_FORMS_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_FORMS_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getForms({days});

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function getSubmissions(days) {
  const request = () => { return { type: GET_SUBMISSIONS_REQUEST } };
  const success = (res) => { return { type: GET_SUBMISSIONS_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_SUBMISSIONS_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getSubmissions({days});

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function getTopViewedForms() {
  const request = () => { return { type: GET_TOP_VIEWED_FORMS_REQUEST } };
  const success = (res) => { return { type: GET_TOP_VIEWED_FORMS_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_TOP_VIEWED_FORMS_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getTop({ limit: 10, resurce: 'form', action: 'viewed' });

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function getTopUsedThemes() {
  const request = () => { return { type: GET_TOP_USED_THEMES_REQUEST } };
  const success = (res) => { return { type: GET_TOP_USED_THEMES_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_TOP_USED_THEMES_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getTop({ limit: 100, resurce: 'theme', action: 'used' });

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

const services = {
  getUsers: async (params) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/statistics/users`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        },
        params
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  getForms: async (params) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/statistics/forms`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        },
        params
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  getSubmissions: async (params) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/statistics/submissions`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        },
        params
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  getTop: async (params) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/statistics/top`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        },
        params
      });

      return response;
    } catch (e) {
      return e.response;
    }
  }
};
